'use client'

import { jsx, jsxs } from 'react/jsx-runtime';
import { baseTheme } from '../../internal/base.mjs';
import { ReadinessProvider } from '../../internal/lifecycles.mjs';
import '../../internal/styled-components.mjs';
import { createGlobalStyle, ThemeProvider } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${(props) => props.theme.typography.fontFamily};
  }
`;
const ConfigProvider = ({
  children,
  tokens,
  experimental
}) => {
  const theme = {
    ...baseTheme,
    ...tokens
  };
  return /* @__PURE__ */ jsx(ReadinessProvider, { experimental, children: /* @__PURE__ */ jsxs(ThemeProvider, { theme, children: [
    /* @__PURE__ */ jsx(GlobalStyle, {}),
    children
  ] }) });
};
ConfigProvider.displayName = "ConfigProvider";

export { ConfigProvider, GlobalStyle };
//# sourceMappingURL=ConfigProvider.mjs.map
